import React, { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { CONSTANTES } from "./utils/Constantes";
import iniciarConfiguracionAPI from "./amplify";
import appRoutes from "./routes";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./styles/styles.scss";
import PrivateRoute from "./components/PrivateRoute";
import Loading from "./components/Loading/Loading";

iniciarConfiguracionAPI();

const App = () => {
  const loading = useSelector((state) => state.general.loading);
  const [validate, setValidate] = useState(false);
  const [role, setRole] = useState([]);
  const validateUser = (value) => setValidate(value);

  const willMount = async () => {
    if (localStorage.getItem("loginFederate") !== "true") {
      try {
        // const user = await Auth.currentAuthenticatedUser();
        // console.log(user)
        //TODO MEJORA EN EL CONTROL DE ACCESOS
        setRole(appRoutes);
        const currentUser = await Auth.currentAuthenticatedUser();
        const roleUser =
          currentUser?.signInUserSession.accessToken.payload["cognito:groups"];
        const roleAdmin =
          (roleUser &&
            roleUser.filter(
              (role) => role == process.env.REACT_APP_ROLE_ADMIN
            )) ||
          "";
        let routesTest;
        let routesConcat=[];
        if (
          roleAdmin.length > 0 &&
          roleAdmin[0] == process.env.REACT_APP_ROLE_ADMIN
        ) {
          routesTest = appRoutes;
          setRole(routesTest);
        } else {      
            for (const roleItem of roleUser) {
              routesTest = null;
              if (roleItem == process.env.REACT_APP_ROLE_CARGA) {
                routesTest = appRoutes.filter(
                  (el) => el.id == 1 || el.id == 2 || el.id == 5 || el.id == 3 || el.id == 12
                );                
              }
              if (roleItem == process.env.REACT_APP_ROLE_CONSULTA) {
                routesTest = appRoutes.filter(
                  (el) => el.id == 1 || el.id == 2 || el.id == 3 || el.id === 5 || el.id == 12
                );                
              }
              if (roleItem == process.env.REACT_APP_ROLE_TRIBUTACION) {
                routesTest = appRoutes.filter(
                  (el) => el.id == 1 || el.id == 2 || el.id == 3 || el.id === 5 || el.id === 11 || el.id == 12
                );                
              }
              if(routesTest && routesTest.length > 0)
                routesConcat = routesConcat.concat(routesTest);
            }
            routesTest = unique(routesConcat);
            setRole(routesTest);
        }
        validateUser(true);
      } catch (e) {
        console.log(e);
        const par = getUrlParams()["error_description"];
        if (par && par.includes("REINTENTAR")) {
          const customProvider = process.env.REACT_APP_OAUTH_PROVIDER;
          await Auth.federatedSignIn({ provider: customProvider });
          validateUser(true);
        } else {
          localStorage.setItem("login", false);
          validateUser(true);
        }
      }
    } else {
      validateUser(true);
    }
  };

  const unique = (array) => {    
      var a = array.concat();
      for(var i=0; i<a.length; ++i) {
          for(var j=i+1; j<a.length; ++j) {
              if(a[i].id === a[j].id)
                  a.splice(j--, 1);
          }
      }  
      return a;  
  }
  useEffect(() => {
    willMount();
  }, []);

  const getUrlParams = () => {
    let query = window.location.search.substring(1);
    let params = query.split("&");
    let data = {};
    params.map(
      (param) =>
        param &&
        Object.assign(data, {
          [param.split("=")[0]]: decodeURIComponent(param.split("=")[1]),
        })
    );
    return data;
  };

  return validate ? (
    <Router basename={CONSTANTES.RUTA.basename}>
      <div className="app_wrapper">
        <div className="app_section_header">
          <Header />
        </div>
        <div className="app_section_content">
          {loading && <Loading />}
          <Switch>
            <Route
              exact
              path={CONSTANTES.RUTA.path}
              render={() => <Redirect to={CONSTANTES.RUTA.login} />}
            ></Route>
            {appRoutes &&
              role.map((prop, key) =>
                prop.private ? (
                  <PrivateRoute
                    key={key}
                    exact={prop.exact}
                    path={prop.path}
                    component={prop.component}
                  />
                ) : (
                  <Route
                    exact={prop.exact}
                    path={prop.path}
                    key={key}
                    component={prop.component}
                  />
                )
              )}
            <Route path="*">
              <Redirect to={CONSTANTES.RUTA.login} />
            </Route>
          </Switch>
        </div>
        <div className="app_section_footer">
          <Footer />
        </div>
      </div>
    </Router>
  ) : null;
};

export default App;
